const GAP_GRANT_CODE = "9999"

export default (jwts) => {
  if (jwts && jwts.account && jwts.account.grants) {
    return jwts.account.grants.some((grant) => (grant.code && grant.code === GAP_GRANT_CODE))
  }
  return false
}
